import type { PromotionSelectionInput } from '@/types';

export const stablePromoSelectionKey = (selections?: PromotionSelectionInput[]): string => {
  if (!selections?.length) return 'auto';
  const normalized = [...selections].sort((a, b) => a.groupId.localeCompare(b.groupId));
  return JSON.stringify(normalized);
};
